import axios from "../axios-auth";

export const checkListFrequencyService = {
    getCheckListFrequencyList,
    saveCheckListFrequency,
    getCheckListFrequencyDetail,
    getCheckListFrequencyByStatus,
}

function getCheckListFrequencyList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortBy
    }

    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/check-list-frequencies", { params });
}

function saveCheckListFrequency(checkListFrequency) {
    if (!checkListFrequency.id) {
        // new check list frequency 
        return axios.post("/auth/check-list-frequency", checkListFrequency);
    } else {
        // edit
        return axios.put("/auth/check-list-frequency", checkListFrequency);
    }
}

function getCheckListFrequencyDetail(id) {
    return axios.get("/auth/check-list-frequency/" + id);
}

function getCheckListFrequencyByStatus(status) {
    return axios.get("/auth/check-list-frequencies-by-status/" + status);
}